import { BOT_FORM_NAME_ERROR_ID, BOT_FORM_NAME_INPUT_ID } from "testIds";
import Input from "common/Inputs/Input";
import React, { useRef } from "react";
import { InputRef } from "antd/es/input";
import { ErrorText, FormFieldTitle } from "features/bots/common/styles";
import { useSharedBotNameInput } from "@shared/features/bots/BotForm/common/hooks";
import { UseSharedBotNameInputProps } from "@shared/features/bots/BotForm/common/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const useBotNameInput = ({
  currentBotId,
  initialize,
}: UseSharedBotNameInputProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const inputRef = useRef<InputRef>(null);

  const {
    botName,
    handleSetName,
    flushName,
    nameError,
    placeholder,
    disabled,
  } = useSharedBotNameInput({
    currentBotId,
    initialize,
  });

  const nameInput = (
    <>
      <FormFieldTitle>{t("labels.bot_name")}</FormFieldTitle>
      <Input
        data-testid={BOT_FORM_NAME_INPUT_ID}
        value={botName}
        onChange={(e) => handleSetName(e.target.value)}
        onBlur={flushName}
        ref={inputRef}
        placeholder={placeholder}
        disabled={disabled}
      />
      {nameError && (
        <ErrorText data-testid={BOT_FORM_NAME_ERROR_ID}>{nameError}</ErrorText>
      )}
    </>
  );

  return {
    nameInput,
    nameError,
  };
};

export default useBotNameInput;
